import { z } from 'zod';
/**
 * Web Push (SPEC 10.1).
 *
 * Die Anmeldung kommt aus `PushSubscription.toJSON()` des Browsers; hier wird
 * genau der Ausschnitt uebernommen, den der Versand braucht.
 */
export const pushSubscriptionSchema = z.object({
    endpoint: z.string().url().max(2000),
    keys: z.object({
        p256dh: z.string().min(1).max(400),
        auth: z.string().min(1).max(400),
    }),
    /** Nur zur Wiedererkennung in der Geraeteliste, nie zur Autorisierung. */
    userAgent: z.string().max(400).optional(),
});
export const pushUnsubscribeSchema = z.object({
    endpoint: z.string().url().max(2000),
});
/**
 * Welche Ereignisse melden sich (SPEC 10.1). Jeder Typ einzeln schaltbar —
 * Ueberbenachrichtigung ist der schnellste Weg, dass die App deinstalliert
 * wird.
 */
export const notificationPrefsSchema = z.object({
    notifyAssigned: z.boolean().optional(),
    notifyDue: z.boolean().optional(),
    notifyReminder: z.boolean().optional(),
    notifyDone: z.boolean().optional(),
    notifyNudge: z.boolean().optional(),
    notifyComment: z.boolean().optional(),
});
/** Sperre zwischen zwei Anmahnungen derselben Karte. */
export const NUDGE_COOLDOWN_MINUTES = 30;
/** Erinnerung mit freiem Vorlauf, hoechstens vier Wochen. */
export const createReminderSchema = z.object({
    offsetMinutes: z.number().int().min(0).max(40_320),
});
//# sourceMappingURL=push.js.map